module.exports = __webpack_public_path__ + "img/coin-saya.3a425cb2.svg";